import React from 'react';
import { NavLink } from "react-router-dom";
import { UserDataStore } from '../store/userDataStore';

export default function Home() {
    const user = UserDataStore.getCurrentUser();

    const isSA = user && user.roleCodes &&
        user.roleCodes.includes('SA');

    return (
        <div id="home-container">
            <div id="home-container-logo" />
            <div className="card-container">

                <NavLink data-testid="goToProductsLink" className="pw-card-link" to="/products">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">architecture</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="productsCard" className="pw-card-main-title">PRODUCT PLANNING</div>
                            <div className="pw-home-card-text">Product NPI and details</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink data-testid="goToRawMaterialsLink" className="pw-card-link" to="/rawmaterialsform">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">brick</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="productsCard" className="pw-card-main-title">CHEMICAL INVENTORY</div>
                            <div className="pw-home-card-text">Chemicals and other raw materials</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/assets-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">adf_scanner</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="assetsCard" className="pw-card-main-title">ASSETS</div>
                            <div className="pw-home-card-text">Asset configuration and validation</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/benchsheetlauncher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">dynamic_form</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="benchSheetsCard" className="pw-card-main-title">QC BENCH SHEETS</div>
                            <div className="pw-home-card-text">QC Bench Sheet forms</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/methods">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">note_alt</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">METHODS</div>
                            <div className="pw-home-card-text">Methods database</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/standards-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">fact_check</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">STANDARDS</div>
                            <div className="pw-home-card-text">Standards maintenance</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/calculator-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">calculate</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">CALCULATORS</div>
                            <div className="pw-home-card-text">Calculators and formulas</div>
                        </div>
                    </div>
                </NavLink>

                {/*<NavLink className="pw-card-link" to="/cofalauncher">*/}
                {/*    <div className="pw-home-page-card">*/}
                {/*        <div className="pw-card-icon-section">*/}
                {/*            <span className="material-symbols-outlined home-card-icon">summarize</span>*/}
                {/*        </div>*/}

                {/*        <div className="pw-card-data-section">*/}
                {/*            <div className="pw-card-main-title">C OF A</div>*/}
                {/*            <div className="pw-home-card-text">Certificates</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</NavLink>*/}

                <NavLink className="pw-card-link" to="/events-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">calendar_clock</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">EVENTS</div>
                            <div className="pw-home-card-text">Event, workflow and task system</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/controlled-documents">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">edit_document</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">DOCUMENTS</div>
                            <div className="pw-home-card-text">Controlled Documents</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/report-designer">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">format_image_right</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">REPORT DESIGNER</div>
                            <div className="pw-home-card-text">Create and manage reports</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/resources">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">apps</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">RESOURCES</div>
                            <div className="pw-home-card-text">Documents and imagery</div>
                        </div>
                    </div>
                </NavLink>

                {isSA &&
                    <NavLink className="pw-card-link" to="/administration">
                        <div className="pw-home-page-card">
                            <div className="pw-card-icon-section">
                                <span className="material-symbols-outlined home-card-icon">settings</span>
                            </div>

                            <div className="pw-card-data-section">
                                <div className="pw-card-main-title">ADMINISTRATION</div>
                                <div className="pw-home-card-text">Adminstrative tools, settings and configurations</div>
                            </div>
                        </div>
                    </NavLink>
                }

                <NavLink className="pw-card-link" to="/tickets">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">assignment_late</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TICKET LOG</div>
                            <div className="pw-home-card-text">Issue reporting and maintenance</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/documentationlauncher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">article</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">DMA HELP</div>
                            <div className="pw-home-card-text">Software help files</div>
                        </div>
                    </div>
                </NavLink>

                {/*
                      <NavLink data-testid="goToRawMaterialsLink" className="pw-card-link" to="/rawmaterials">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">category</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="rawMaterialsCard" className="pw-card-main-title">RAW MATERIALS</div>
                            <div className="pw-home-card-text"></div>
                        </div>
                    </div>
                </NavLink>

                 <NavLink className="pw-card-link" to="/test-spec-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">book</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">Test Specs</div>
                            <div className="pw-home-card-text"></div>
                        </div>
                    </div>
                </NavLink>

                    <div className="pw-home-page-card cursor-pointer" onClick={onShowDemoIcons}>
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-orange">destruction</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-orange">Demos</div>
                        </div>
                    </div>

                    <NavLink className="pw-card-link" to="/workflow-management">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-orange">account_tree</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-orange">WORKFLOW</div>
                        </div>
                    </div>
                </NavLink>
                    */}



            </div>
        </div>
    )

}

